var map = {
	"./1.svg": 9002,
	"./2.svg": 9112,
	"./3.svg": 589,
	"./4.svg": 5854,
	"./5.svg": 8177,
	"./6.svg": 5565,
	"./7.svg": 1901,
	"./8.svg": 7708,
	"./9.svg": 2127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2989;